import trans from "../../../../utils";

export default function WorkforceTotals({ title, number }) {
  // Vehicles - Speed - Distance - Fuel
  return (
    <div className="report-sheet-total">
      <div className="text-capitalize mb-2">{trans(title)}</div>
      <div className="fw-700 fs-18">{number} </div>
    </div>
  );
}
